var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-empty-state',{attrs:{"title":_vm.emptyState.title,"description":_vm.emptyState.description,"svg-path":_vm.emptyState.svgPath,"svg-height":145,"header-level":3,"primary-button-link":_vm.buttonLink,"primary-button-text":_vm.emptyState.buttonText}})
}
var staticRenderFns = []

export { render, staticRenderFns }